import BaseService from "./baseService";
import cloneDeep from "lodash/cloneDeep";

class BroadcastNotificationService extends BaseService {
  async sendBroadcastNotification(payload, opts = {}) {
    this.endPoint = "/send-notification-broadcast";
    const newOpts = cloneDeep(opts, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return await this.post(payload, newOpts);
  }
}

export default new BroadcastNotificationService();
